var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "form-fields-address pt-2 pb-0" }, [
    !_vm.addressStatus
      ? _c(
          "div",
          {
            staticClass:
              "b-1-gray-05 gray-0-bkg flex-row jc-space lh-20 p-3 br form-fields-address-saved"
          },
          [
            _c("ul", { staticClass: "my-0" }, [
              _c("li", { staticClass: "semibold" }, [
                _vm._v(_vm._s(_vm.addressName))
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "semibold" }, [
                _vm._v(_vm._s(_vm.addressType.label))
              ]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.addressSettings.line1))]),
              _vm._v(" "),
              _vm.addressSettings.line2
                ? _c("li", [_vm._v(_vm._s(_vm.addressSettings.line2))])
                : _vm._e(),
              _vm._v(" "),
              _vm.addressSettings.postalCode
                ? _c("li", [_vm._v(_vm._s(_vm.addressSettings.postalCode))])
                : _vm._e(),
              _vm._v(" "),
              _vm.addressSettings.city
                ? _c("li", [_vm._v(_vm._s(_vm.addressSettings.city))])
                : _vm._e(),
              _vm._v(" "),
              _vm.addressSettings.state
                ? _c("li", [_vm._v(_vm._s(_vm.addressSettings.state))])
                : _vm._e(),
              _vm._v(" "),
              _vm.addressSettings.country
                ? _c("li", [_vm._v(_vm._s(_vm.addressSettings.country))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.addressFieldsStatus !== "pending"
              ? _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: { href: "javascript:;", type: "secondary" },
                    on: {
                      click: function($event) {
                        return _vm.switchToEditView()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$l10n.__("Modifier")))]
                )
              : _vm._e()
          ]
        )
      : _c(
          "div",
          [
            _c(
              "el-form-item",
              { attrs: { prop: _vm.currentAddress.name } },
              [
                _c(
                  "span",
                  {
                    staticClass: "gray-100",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$l10n.__("Nom de l'adresse")))]
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    autocomplete: "off",
                    "data-bot": _vm.getDatabot(
                      "name",
                      _vm.currentStore,
                      "address"
                    )
                  },
                  model: {
                    value: _vm.addressName,
                    callback: function($$v) {
                      _vm.addressName = $$v
                    },
                    expression: "addressName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { prop: _vm.currentAddress.name } },
              [
                _c(
                  "span",
                  {
                    staticClass: "gray-100",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$l10n.__("Type")))]
                ),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "wp-10",
                    attrs: {
                      "data-bot": _vm.getDatabot(
                        "type",
                        _vm.currentStore,
                        "address"
                      )
                    },
                    model: {
                      value: _vm.addressType,
                      callback: function($$v) {
                        _vm.addressType = $$v
                      },
                      expression: "addressType"
                    }
                  },
                  _vm._l(_vm.addressTypeList, function(option) {
                    return _c("el-option", {
                      key: option.label,
                      attrs: {
                        value: option,
                        label: option.label,
                        disabled: option.disable
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("address-input", {
              scopedSlots: _vm._u([
                {
                  key: "manualAddress",
                  fn: function(ref) {
                    var data = ref.data
                    var updateCountry = ref.updateCountry
                    return [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "my-2",
                          attrs: { prop: _vm.currentAddress.settings.line1 }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gray-100",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$l10n.__("Adresse")))]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              "data-bot": _vm.getDatabot(
                                "address",
                                _vm.currentStore,
                                "address"
                              )
                            },
                            model: {
                              value: data.line1,
                              callback: function($$v) {
                                _vm.$set(data, "line1", $$v)
                              },
                              expression: "data.line1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.currentAddress.settings.line2,
                            label: _vm.$t.__(
                              "common.labels.more_address_informations"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              "data-bot": _vm.getDatabot(
                                "more-infos",
                                _vm.currentStore,
                                "address"
                              )
                            },
                            model: {
                              value: data.line2,
                              callback: function($$v) {
                                _vm.$set(data, "line2", $$v)
                              },
                              expression: "data.line2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "wp-5",
                          attrs: {
                            prop: _vm.currentAddress.settings.postalCode
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gray-100",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$l10n.__("Code postal")))]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "wp-10",
                            attrs: {
                              type: "number",
                              controls: false,
                              autocomplete: "off",
                              "data-bot": _vm.getDatabot(
                                "zip",
                                _vm.currentStore,
                                "address"
                              )
                            },
                            model: {
                              value: data.postalCode,
                              callback: function($$v) {
                                _vm.$set(data, "postalCode", $$v)
                              },
                              expression: "data.postalCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: _vm.currentAddress.settings.city } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gray-100",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$l10n.__("Ville")))]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              "data-bot": _vm.getDatabot(
                                "country",
                                _vm.currentStore,
                                "city"
                              )
                            },
                            model: {
                              value: data.city,
                              callback: function($$v) {
                                _vm.$set(data, "city", $$v)
                              },
                              expression: "data.city"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.updateState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: _vm.currentAddress.settings.state,
                                label: _vm.$t.__("common.labels.state")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: data.state,
                                  callback: function($$v) {
                                    _vm.$set(data, "state", $$v)
                                  },
                                  expression: "data.state"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { prop: _vm.currentAddress.settings.country }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gray-100",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$l10n.__("Pays")))]
                          ),
                          _vm._v(" "),
                          _c("country-input", {
                            attrs: {
                              "data-bot": _vm.getDatabot(
                                "country",
                                _vm.currentStore,
                                "address"
                              ),
                              "default-value": {
                                code: data.countryCode,
                                name: data.country
                              }
                            },
                            on: { change: updateCountry }
                          })
                        ],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "algoliaWrapper",
                  fn: function(ref) {
                    var methods = ref.methods
                    var props = ref.props
                    var data = ref.data
                    return [
                      _c(
                        "el-form-item",
                        {
                          class: { hide: data.currentValue.manualMode },
                          attrs: {
                            prop: _vm.currentAddress.settings.line1,
                            label: _vm.$t.__("common.labels.address")
                          }
                        },
                        [
                          _c("algolia-input", {
                            staticClass: "algolia-input--no-icon",
                            attrs: {
                              "element-name": props.value._id,
                              "place-type": "address",
                              "data-bot": _vm.getDatabot(
                                "address",
                                _vm.currentStore,
                                "address"
                              )
                            },
                            on: { "bubble-address": methods.captureAddress }
                          }),
                          _vm._v(" "),
                          _c("CompassPlainButton", {
                            attrs: {
                              label: props.manuallyLabel,
                              "data-bot": _vm.getDatabot(
                                "address-link-add",
                                _vm.currentStore,
                                "address"
                              )
                            },
                            on: { click: methods.switchMode }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.addressSettings,
                callback: function($$v) {
                  _vm.addressSettings = $$v
                },
                expression: "addressSettings"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-row" },
              [
                _vm.index > 0
                  ? _c("CompassButton", {
                      staticClass: "wp-5 mt-2",
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.remove()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "wp-5 mt-2",
                  class: { "wp-10": _vm.index === 0 },
                  attrs: {
                    label: _vm.$t.__("common.actions.save"),
                    type: "primary",
                    disabled: !_vm.validForm,
                    "data-bot": _vm.getDatabot(
                      "btn",
                      _vm.currentStore,
                      "address"
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.saveUpdates()
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }